<template>
  <router-view />
</template>

<script>
export default {
  name: 'Withdrawal'
};
</script>
